export default __webpack_public_path__ + "static/media/Strugani 14.d43bdbaf.jpg";